import { render, staticRenderFns } from "./CompetitionsCreate.vue?vue&type=template&id=90013936&"
import script from "./CompetitionsCreate.vue?vue&type=script&lang=ts&"
export * from "./CompetitionsCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports